import React from 'react'
import './InfoAboutTrip.css'
import prettyDateTime from '../function/prettyDateTime'

const InfoAboutTrip = ({InfoAboutTrip}) => {
    const status = InfoAboutTrip.status
    // Neplánovaná jízda
    if(status === 1 && InfoAboutTrip.bookTime === null) {
        return (
            <div className='ContainerStatusInfo'>
              <p>Do 5 min přijmeme Vaší zakázku.</p>
              <h2>Prosím sledujte telefon.</h2>
            </div>
          )
    }
    // Plánovaná
    else if(status === 1 && InfoAboutTrip.bookTime !== null){
      return (
          <div className='ContainerStatusInfo'>
            <p>Naplánovaná jízda</p>
            <p>{ prettyDateTime(InfoAboutTrip.bookTime) }</p>
            <h2>Jakmile řidič dorazí, pošle SMS.</h2>
          </div>
        )
  }
    else if(status === 2){
        return (
            <div className='ContainerStatusInfo'>
              <p>Řidič přijal zakázku a vyráží za Vámí.</p>
              <h2>Jakmile řidič dorazí, pošle SMS.</h2>
            </div>
          )
    }
    else if(status === 3){
        return (
            <div className='ContainerStatusInfo'>
              <p>Řidič dorazil na Vaší adresu.</p>
            </div>
          )
    }
    else if(status === 7){
        return (
            <div className='ContainerStatusInfo'>
              <p>Řidič na Vás čeká.</p>
            </div>
          )
    }
    else if(status === 4){
        return (
            <div className='ContainerStatusInfo'>
              <p>Jste na cestě do cílové destinace.</p>
            </div>
          )
    }

}

export default InfoAboutTrip
